<template>
  <div>
    <div class="login-container reset-pass-container">
      <div class="login-wrapper">
          <section class="login-content">

            <!-- activate:start -->
            <div class="m-box signup" v-show="(state == 'activate')">

            <h1>{{$t('activate.title')}}</h1>
            <p class="mb-3 body-2">
              {{$t('activate.detail')}}
            </p>

            <div v-show="cognitoErrorMsg">
              <div class="orange--text" role="alert">
                <button class="close" type="button"  aria-label="Close">
                </button>
                {{ cognitoErrorMsg }}
              </div>
            </div>

            <v-form v-model="activationFormValid">

              <v-text-field
                color="white"
                :label="$t('user-params.username')"
                v-model="username"
                :rules="usernameRules"
                required
              ></v-text-field>

              <v-text-field color="white"
              :label="$t('activate.temp_password')"
              v-model="password"
              :rules="passwordRules"
              required
              :append-icon="passwordVisible? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (passwordVisible = !passwordVisible)"
              :type="passwordVisible ? 'text':'password'"
              >
              </v-text-field>

              <v-text-field color="white"
              :label="$t('activate.newpassword')"
              v-model="newPassword"
              :rules="passwordRules"
              required
              :append-icon="newPasswordVisible? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (newPasswordVisible = !newPasswordVisible)"
              :type="newPasswordVisible ? 'text':'password'"
              v-on:keyup="passwordReinputValidate"
              >
              </v-text-field>

              <v-text-field color="white"
              ref="passwordReinput"
              :label="$t('activate.passwordreinput')"
              v-model="passwordReinput"
              :rules="passwordReinputRules"
              required
              :append-icon="passwordReinputVisible? 'visibility' : 'visibility_off'"
              :append-icon-cb="() => (passwordReinputVisible = !passwordReinputVisible)"
              :type="passwordReinputVisible ? 'text':'password'"
              >
              </v-text-field>

              <div class="mt-4 ">
                <v-card flat class="ma-1 pa-3 body-2 grey black--text" >
                  <div v-html="$t('activate.agreement_msg')" id="EULA"></div>
                </v-card>
              </div>
              <div class="body-1 ml-1 mt-3">
              <v-checkbox
                :label="$t('activate.agree')"
                v-model="agree"
                required
                :rules="checkboxRules"
                class="body-1 activate-agree-checkbox"
              >
              </v-checkbox></div>

              <v-btn  v-on:click="activate" :disabled="!activationFormValid || submitted"
                :class="!activationFormValid || submitted?'grey lighten-1':'blue'"
              >
                {{$t("activate.submit")}}
              </v-btn>

            </v-form>
          </div>
          <!-- activate:end -->


          <!-- complete:start -->
          <div v-show="(state == 'complete')">
              <p class="white--text">{{$t("activate.complete")}}</p>
              <v-btn class="blue" to="/login">{{$t("login.login")}}</v-btn>
          </div>
          <!-- complete:end -->

          </section>


        <login-footer/>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint semi: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */
import http from '@/utils/http.js'
import LoginFooter from '@/pages/LoginFooter'

export default {
  components: {
    LoginFooter
  },
  data () {
    return {
      activationFormValid: true,
      state: 'activate', // or 'complete'
      username: this.$route.query.username ? this.$route.query.username : '',
      password: this.$route.query.temppass ? this.$route.query.temppass : '',
      newPassword: '',
      passwordReinput: '',
      passwordVisible: true,
      newPasswordVisible: false,
      passwordReinputVisible: false,
      agree: false,
      cognitoErrorMsg: '',
      submitted: false,  // submitフラグ
      // 追加
      name: '',
      usernameRules: [
        (v) => !!v || this.$t('login.vali-username-blank')
      ],
      checkboxRules: [
        (v) => !!v || 'You must agree.'
      ],
      passwordRules: [
        (v) => !!v || this.$t('resetpassword.vali-pass-blank'),
        (v) => /[0-9]+/.test(v) && /[a-z]+/.test(v) || this.$t('resetpassword.vali-pass-number'),
        (v) => !/[¥ ]+/.test(v) || this.$t('resetpassword.vali-pass-whitespace'),
        (v) => v.length >= 8 || this.$t('resetpassword.vali-pass-length')
      ],
      passwordReinputRules: [
        (v) => !!v || this.$t('resetpassword.vali-pass-blank'),
        (v) => this.newPassword === v || this.$t('user-params.password_reinput_differs')
      ]
      // ここまで
    }
  },
  methods: {
    activate () {
      this.submitted = true // ボタン無効化
      this.clearErrorMessage()
      this.activate_created_by_aplix()
    },
    activate_created_by_aplix () {
      http.request('post', '/service2/dashboard/api/accounts/activate', {
        username: this.username,
        password: this.password,
        newPassword: this.newPassword
      })
      .then(response => {
        const data = response.data
        if (data.result !== 0) {
          let errstr = JSON.strigify(response)
          console.error(errstr)
          switch (data.result) {
            case -102:
              this.cognitoErrorMsg = this.$t('account.fail-username')
              break
            default:
              this.cognitoErrorMsg = this.$t('cognitoError.UnknownError')// + '\n(' + errstr + ')')
          }
        } else {
          // success
          this.state = 'complete'
        }
        this.submitted = false // ボタン有効化
        
      }).catch((err) => {
        let cognitoExceptionName = err['response']['data']
        let cognitoError = this.$t('cognitoError.' + cognitoExceptionName)
        if (cognitoError === 'cognitoError.' + cognitoExceptionName) {
          cognitoError = this.$t('cognitoError.UnknownError')
        }
        this.cognitoErrorMsg = cognitoError
        cognitoError += '\n(' + JSON.stringify(err) + ')'
        console.error(cognitoError)
        this.submitted = false // ボタン有効化
      })
    },
    goToNext () {
      window.location.href = '/dashboard/'
    },
    termsUrl () {
      return process.env.termsUrl
    },
    privacyUrl () {
      return process.env.privacyUrl
    },
    clearErrorMessage () {
      this.cognitoErrorMsg = ''
    },
    passwordReinputValidate () {
      this.$refs.passwordReinput.validate()
    }
  },
  mounted () {
    // TODO: セッションからトークンを拾うようにする（メモリだと別タブの場合リセットされない）
    this.$store.dispatch('logout')
    .then(() => {
      console.log('logout')
    })
    .catch(err => {
      console.log(err)
    })
  }
}
</script>
<style>
.activate-agree-checkbox .icon--selection-control{
  top:9px; /* TODO: 直書き*/
}

.input-group__error {
  color: red!important;
}

#EULA {
  text-align: left;
}
</style>

<style scoped>
.login-content {
  padding-top: 20px;
}
.login-wrapper{
  overflow-y: auto;
}
.login-bottom {
  margin-top: 100px;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// Activate.vue?88c3dc08